<template>
  <div class="bm-price-notice" >
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'PriceNotice'
}
</script>

<style lang="scss">
  .bm-price-notice {

  }
</style>



// WEBPACK FOOTER //
// src/pages/customer-service/price-notice.vue